import { RiskRanges } from "../ranges";
import { Risk } from "../units";

function rangesFor({
  age,
  isScore2HighRisk,
}: {
  age: number;
  isScore2HighRisk: boolean;
}): RiskRanges<"mmol/L"> {
  if (isScore2HighRisk) {
    if (age >= 50) {
      return new RiskRanges("mmol/L", [
        { from: 5.3, to: 7, risk: Risk.HighRisk, label: "high" },
        { from: 1.8, to: 5.3, risk: Risk.Normal, label: "normal" },
        { from: 0.5, to: 1.8, risk: Risk.Optimal, label: "optimal" },
      ]);
    }

    if (age >= 31) {
      return new RiskRanges("mmol/L", [
        { from: 4.7, to: 7, risk: Risk.HighRisk, label: "high" },
        { from: 1.8, to: 4.7, risk: Risk.Normal, label: "normal" },
        { from: 0.5, to: 1.8, risk: Risk.Optimal, label: "optimal" },
      ]);
    }

    if (age >= 18) {
      return new RiskRanges("mmol/L", [
        { from: 4.3, to: 7, risk: Risk.HighRisk, label: "high" },
        { from: 1.8, to: 4.3, risk: Risk.Normal, label: "normal" },
        { from: 0.5, to: 1.8, risk: Risk.Optimal, label: "optimal" },
      ]);
    }
  } else {
    if (age >= 50) {
      return new RiskRanges("mmol/L", [
        { from: 5.3, to: 7, risk: Risk.HighRisk, label: "high" },
        { from: 3.0, to: 5.3, risk: Risk.Normal, label: "normal" },
        { from: 0.5, to: 3.0, risk: Risk.Optimal, label: "optimal" },
      ]);
    }

    if (age >= 31) {
      return new RiskRanges("mmol/L", [
        { from: 4.7, to: 7, risk: Risk.HighRisk, label: "high" },
        { from: 3.0, to: 4.7, risk: Risk.Normal, label: "normal" },
        { from: 0.5, to: 3.0, risk: Risk.Optimal, label: "optimal" },
      ]);
    }

    if (age >= 18) {
      return new RiskRanges("mmol/L", [
        { from: 4.3, to: 7, risk: Risk.HighRisk, label: "high" },
        { from: 3.0, to: 4.3, risk: Risk.Normal, label: "normal" },
        { from: 0.5, to: 3.0, risk: Risk.Optimal, label: "optimal" },
      ]);
    }
  }

  // If age is NaN we return an empty array
  return new RiskRanges("mmol/L", []);
}

export const LDL = {
  rangesFor,
};
